import { Trans } from 'react-i18next';
import { tA11y } from '@lwtears/lwt-common-frontend/lib/@common/util';
import { Box, Typography } from '@mui/material';
import { ActivityTypes } from '../../providers/GameProvider/types';

type AlertBodyProps = {
  activityType: string;
  letter: string;
  bookTitle: string | undefined;
};

const ActivityCompletionAlertBody: React.FC<AlertBodyProps> = ({
  activityType,
  letter,
  bookTitle,
}) => {
  const translateOptions = {
    [ActivityTypes.FIND_THE_LETTER]: {
      letter: `${letter.toUpperCase()}${letter.toLowerCase()}`,
      bookTitle,
    },
    [ActivityTypes.FIND_THE_OBJECTS]: {
      letter: letter.toLowerCase(),
    },
  };
  const alertText = tA11y(`activities.FindIt.${activityType}Alert`, translateOptions[activityType]);

  return (
    <Box marginTop={1}>
      <Typography variant="subtitle1">
        <Trans>{alertText}</Trans>
      </Typography>
    </Box>
  );
};

export default ActivityCompletionAlertBody;
